import React from 'react'
import { Progress, Space, Table, Tag } from 'antd';
const buttonSvg= <svg xmlns="http://www.w3.org/2000/svg" width="95" height="95" viewBox="1639 2708.95 95 95"><g data-name="Group 19013"><path d="M0 47.4a47.5 47.5 0 1 1 0 .1z" fill-rule="evenodd" fill="url(&quot;#a&quot;)" transform="translate(1639 2709)" data-name="Ellipse 2910"/><path d="M0 32.4a32.5 32.5 0 1 1 0 .1z" fill-rule="evenodd" fill="url(&quot;#b&quot;)" transform="translate(1654 2724)" data-name="Ellipse 2898"/><path d="m1689.181 2756.996-8.937-8.93a1.68 1.68 0 0 1 0-2.384 1.702 1.702 0 0 1 2.39 0l10.126 10.118c.64.64.654 1.667.05 2.328l-10.168 10.188c-.33.33-.766.492-1.195.492-.43 0-.865-.162-1.196-.492a1.68 1.68 0 0 1 0-2.384l8.93-8.936Z" fill="#fff" fill-rule="evenodd" data-name="Icon ionic-ios-arrow-forward"/></g><defs><linearGradient x1="1" y1="0" x2="0" y2="1" id="a"><stop stop-color="#ffebfe" offset="0"/><stop stop-color="#fff6e6" offset="1"/></linearGradient><linearGradient x1="1" y1="0" x2="0" y2="1" id="b"><stop stop-color="#f518e3" offset="0"/><stop stop-color="#fbae24" offset="1"/></linearGradient></defs></svg>
const CURRENCY_FORMATTER= new Intl.NumberFormat(undefined, {
    currency: "MNT", style: "currency"
})

export function formatCurrency(number){
    return CURRENCY_FORMATTER.format(number)
}
const data = [
    {
      key: '1',
      name: 25,
      age: "Эрүүл мэндийн төвийн барилга, 15 ор /Өвөрхангай, Төгрөг сум, 1 дүгээр баг/",
      address: 35154351,
      tags: 35154351
    },
    {
      key: '2',
      name: 54,
      age: "Эрүүл мэндийн төвийн барилга, 15 ор /Өвөрхангай, Төгрөг сум, 1 дүгээр баг/",
      address: 35154351,
      tags: 35154351,
    },
    {
      key: '3',
      name: 100,
      age: "Эрүүл мэндийн төвийн барилга, 15 ор /Өвөрхангай, Төгрөг сум, 1 дүгээр баг/",
      address: 35154351,
      tags: 35154351
    },
  ];
  const columns = [
    {
      title: 'ЯВЦ',
      dataIndex: 'name',
      key: 'name',
      render: (text) => 
      <div><Progress trailColor={"#ef3c3c" } status='active'  percent={text} type="circle" width={80}/></div>,
    },
    {
      title: 'ТӨСЛИЙН НЭР',
      dataIndex: 'age',
      key: 'age',
      render: (text)=>(
        <div style={{width: "100%",display: "flex", justifyContent: "center"}}><div style={{width: "70%"}}>{text}</div></div>
      )
    },
    {
      title: 'ХҮСЭЛТ',
      dataIndex: 'address',
      key: 'address',
      render: (text)=>(
        <span style={{fontWeight: "600"}}>{formatCurrency(text)}</span>
      )
    },
    {
      title: 'ОЛГОСОН',
      key: 'tags',
      dataIndex: 'tags',
      render: (text)=>(
        <span style={{fontWeight: "600"}}>{formatCurrency(text)}</span>
      )
    },
    {
      title: 'АЖЛЫН ГҮЙЦЭТГЭЛ',
      key: 'action',
      render: () => (
        <div className='execution-button' style={{display: "flex", flexDirection: "column", justifyContent:"center", alignItems: "center"}}>
        <div ><svg style={{width: "3.5rem", height: "3.5rem"}} xmlns="http://www.w3.org/2000/svg" width="95" height="95" viewBox="1639 2708.95 95 95"><g data-name="Group 19013"><path d="M0 47.4a47.5 47.5 0 1 1 0 .1z" fill-rule="evenodd" fill="url(&quot;#a&quot;)" transform="translate(1639 2709)" data-name="Ellipse 2910"/><path d="M0 32.4a32.5 32.5 0 1 1 0 .1z" fill-rule="evenodd" fill="url(&quot;#b&quot;)" transform="translate(1654 2724)" data-name="Ellipse 2898"/><path d="m1689.181 2756.996-8.937-8.93a1.68 1.68 0 0 1 0-2.384 1.702 1.702 0 0 1 2.39 0l10.126 10.118c.64.64.654 1.667.05 2.328l-10.168 10.188c-.33.33-.766.492-1.195.492-.43 0-.865-.162-1.196-.492a1.68 1.68 0 0 1 0-2.384l8.93-8.936Z" fill="#fff" fill-rule="evenodd" data-name="Icon ionic-ios-arrow-forward"/></g><defs><linearGradient x1="1" y1="0" x2="0" y2="1" id="a"><stop stop-color="#ffebfe" offset="0"/><stop stop-color="#fff6e6" offset="1"/></linearGradient><linearGradient x1="1" y1="0" x2="0" y2="1" id="b"><stop stop-color="#f518e3" offset="0"/><stop stop-color="#fbae24" offset="1"/></linearGradient></defs></svg></div>
        <div style={{fontWeight: "600", fontSize: ".875rem", color: "var(--gray-text)"}}>дэлгэрэнгүй үзэх</div>
        </div>
      ),
    },
  ];
function TableComponent() {
  return (
    <div className='tableComponent-container'>
        <Table style={{width:"85%", marginTop: "1rem", marginLeft: "1rem"}} columns={columns} dataSource={data}/>
    </div>
  )
}

export default TableComponent